Begin function declaration.

    sayHello = ->

Print a greeting.

      console.log 'hi'
